import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Geplaatst op:", -1)
const _hoisted_5 = ["innerHTML"]

import { useRoute, useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import { generalStore } from '@/stores/general'
import axios from 'axios'
import Filelist from '@/components/news/Filelist.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsItem',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const newsItem = ref(null)

onMounted(() => {
  getNewsItem()
})

function getNewsItem () : void {
  axios.get(process.env.VUE_APP_API_URL + '/news/' + route.params.newsId).then((r) => {
    newsItem.value = r.data.data
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, null, _createSlots({
            extra: _withCtx(() => [
              (_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Terug naar dashboard")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (newsItem.value)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 0,
                    gutter: [24,24],
                    class: "no-mb"
                  }, {
                    default: _withCtx(() => [
                      (newsItem.value.img)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 0,
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 6}
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: newsItem.value.img.url,
                                style: {"width":"100%"}
                              }, null, 8, _hoisted_1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_col, {
                        xs: {span: 24},
                        sm: {span: 24},
                        md: {span: 24},
                        lg: {span: newsItem.value.img ? 18 : 24}
                      }, {
                        default: _withCtx(() => [
                          (!_unref(generalStore)().desktop)
                            ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(newsItem.value ? newsItem.value.title : 'Aan het laden..'), 1))
                            : _createCommentVNode("", true),
                          (newsItem.value.published_at)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                                _hoisted_4,
                                _createTextVNode(" " + _toDisplayString(new Date(newsItem.value.published_at).toLocaleDateString('nl-NL')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            innerHTML: newsItem.value.body
                          }, null, 8, _hoisted_5)
                        ]),
                        _: 1
                      }, 8, ["lg"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_skeleton, {
                    key: 1,
                    active: ""
                  }))
            ]),
            _: 2
          }, [
            (_unref(generalStore)().desktop)
              ? {
                  name: "title",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(newsItem.value ? newsItem.value.title : 'Aan het laden..'), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1024)
        ]),
        _: 1
      }),
      (newsItem.value && newsItem.value.extra.length)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, { title: "Bijlages" }, {
                default: _withCtx(() => [
                  _createVNode(Filelist, {
                    media: newsItem.value.extra
                  }, null, 8, ["media"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})